import { RefObject, useCallback } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import * as ST from './styled';

interface IHeaderProps {
    cityIn: string,
    routersRef?: RefObject<HTMLDivElement>,
}

const Header = ({ cityIn, routersRef }: IHeaderProps): JSX.Element => {
    const onClickHandler = useCallback(() => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.equipment,
            action: ACTIONS.clickChooseBtn,
            label: '',
        });
        routersRef?.current?.scrollIntoView({
            behavior: 'smooth',
        });
    }, [routersRef]);

    return (
        <ST.HeaderWrapper>
            <ST.HeaderContent>
                <ST.HeaderPreTitle>Wi-Fi роутеры в&nbsp;{cityIn}</ST.HeaderPreTitle>
                <ST.HeaderTitle>Танцуйте с&nbsp;удовольствием, а&nbsp;не&nbsp;с&nbsp;бубном у&nbsp;роутера</ST.HeaderTitle>
                <ST.HeaderSubTitle>
                    Простые в&nbsp;настройке, лёгкие в&nbsp;управлении, надёжные в&nbsp;работе и&nbsp;с&nbsp;доставкой по&nbsp;всей России. Выберите свой.
                </ST.HeaderSubTitle>
                <ST.SBaseButton
                    type={btnTypes.ACCENT}
                    size={btnSizes.LARGE}
                    text={'Выбрать роутер'}
                    onClick={onClickHandler}
                />
            </ST.HeaderContent>
            <ST.HeaderMedia>
                <WebpImage urlWebp={'/static/images/equipment/header.webp'}>
                    <ST.HeaderImage
                        src='/static/images/equipment/header.png'
                        alt='Изображение роутера на фоне танцующих людей'
                    />
                </WebpImage>
            </ST.HeaderMedia>
        </ST.HeaderWrapper>
    );
};

export default Header;
